import { FC } from 'react';

import { SuggestionsNoResults } from '../../SuggestionsNoResults/SuggestionsNoResults';
import { NoSuggestionsRecommendations } from './NoSuggestionsRecommendations';

type Props = {
    keyword: string;
    isNavBar: boolean;
};

export const NoSuggestions: FC<Props> = ({ keyword, isNavBar }) => {
    return (
        <>
            <SuggestionsNoResults keyword={keyword} />
            <NoSuggestionsRecommendations isNavBar={isNavBar} />
        </>
    );
};
